import { object, string, TypeOf } from "zod";

export const CONTACT_FORM_CHARS_MAX = 500;

export const contactFormValidation = object({
  name: string().min(1, "Nombre obligatorio"),
  surname: string().min(1, "Apellido obligatorio"),
  email: string().email("Email inválido"),
  message: string().min(1, "Mensaje obligatorio").max(CONTACT_FORM_CHARS_MAX, `Numero máximo de carácteres de ${CONTACT_FORM_CHARS_MAX} superado`),
});

export type IContactFormValidation = TypeOf<typeof contactFormValidation>;